var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay"},[_c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal__title"},[_c('span',[_vm._v("Session Expired")])]),_c('div',{staticClass:"p-3"},[_c('p',[_vm._v("You have left this browser idle for 10 minutes.")]),_c('p',[_vm._v("10 second left")])])])])
}]

export { render, staticRenderFns }